document.addEventListener('crPickupActivated', function (e) {
  jqCR('#storeUL > li > a').each(function(){
    var storeId = jqCR(this).data('store-id');
    var zipCode = jqCR(this).data('zip-code');
    var city = jqCR(this).data('city');
    var storeName = jqCR(this).data('name');
    var storeAddress = jqCR(this).data('address');
    var storeCompany = jqCR(this).data('company');    

	var locationDescription = storeName;
    
    var content = jqCR(this).find('div:nth-child(2)').html(locationDescription);  
  })
})